import enumsDE from './de/messages/enums.json';
import enumsEN from './en/messages/enums.json';
import enumsFR from './fr/messages/enums.json';
import enumsNL from './nl/messages/enums.json';

export const EnumMessagesDE = enumsDE;
export const EnumMessagesEN = enumsEN;
export const EnumMessagesFR = enumsFR;
export const EnumMessagesNL = enumsNL;
